if (!customElements.get("gift-product-module")) {
  customElements.define(
    "gift-product-module",
    class GiftProductModule extends HTMLElement {
      constructor() {
        super();
        this._swiper = null;
        this._resizeHandler = this._init.bind(this);
      }

      connectedCallback() {
        this.swiperStatus = this.classList.contains('gift-product-module-layout-vertical') === true;
        this._init();
        console.log("GiftProductModule connectedCallback", this.swiperStatus);
        window.addEventListener('resize', this._resizeHandler);
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this._resizeHandler);
        if (this._swiper) {
          this._swiper.destroy(true, true);
          this._swiper = null;
        }
      }

      _init() {
        const w = window.innerWidth;

        if (w > 768 || this.swiperStatus) {
          if (!this._swiper) {
            const container = this.querySelector('.gift-product-swiper');
            const nextEl = this.querySelector('.swiper-button-next');
            const prevEl = this.querySelector('.swiper-button-prev');
            const paginationEl = this.querySelector('.swiper-pagination');
            if (container && typeof Swiper === 'function') {
              this._swiper = new Swiper(container, {
                slidesPerView: 'auto',
                // spaceBetween: 24,
                navigation: {
                  nextEl,
                  prevEl,
                },
                pagination: {
                  el: paginationEl || null,
                  clickable: true,
                }
                // breakpoints: {
                //   1200: { slidesPerView: 4 },
                //   768: { slidesPerView: 3 },
                // },
              });
            }
          }
        } else {
          if (this._swiper && !this.swiperStatus) {
            this._swiper.destroy(true, true);
            this._swiper = null;
          }
        }
      }
    })
}